import * as React from 'react'
import styled from 'styled-components'

import * as behaviours from '../../../behaviours'
import * as S from '../../../styles'

import { TimeInput, type TimeInputProps } from '../time/TimeInput'

import { Field } from './Field'
import { FieldStatus } from './FieldStatus'

export type TimeFieldProps = TimeInputProps & {
  context?: string
  description?: string
  error?: React.ReactNode
  help?: React.ReactNode
  /** @default String(Math.random()) */
  label?: React.ReactNode
  success?: React.ReactNode
}

function TimeFieldComponent({
  children,
  className,
  context,
  description,
  error,
  help,
  id,
  label,
  success,
  ...inputProps
}: TimeFieldProps): React.ReactElement<TimeFieldProps> {
  const stableId = React.useId()

  const { classList, status } = behaviours.getStatusClassName(className, error, success)

  return (
    <TimeFieldWrapper
      className={classList.filter(Boolean).join(' ')}
      context={context}
      htmlFor={id ?? stableId}
      label={label}
      description={description}
      help={help}
    >
      {children}
      <TimeInput {...inputProps} status={status} />
      {(error || success) && <FieldStatus error={error} success={success} />}
    </TimeFieldWrapper>
  )
}

export const TimeFieldWrapper = styled(Field)`
  ${S.field.Message} {
    margin-top: 4px;
  }

  ${S.input.Count} {
    margin-top: 4px;
    flex: 0 0 auto;
    margin-left: auto;
  }

  ${S.field.Title}, ${S.field.Description} {
    margin-bottom: 7px;
  }

  ${S.input.Input} {
    width: 100%;
  }
`

/** will forward any other props to the underlying `<input>` */
export const TimeField = styled(TimeFieldComponent)<TimeFieldProps>``
TimeField.displayName = 'TimeField'
